/**
 *
 * v.1.0  26/09/25  Inicial
 **/

import React from 'react'
import PropTypes from 'prop-types';
import { SketchPicker } from "react-color";
class InputColor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: props.color || "#ffffff",      // color confirmado
            tempColor: props.color || "#ffffff",  // color provisional del picker
            showPicker: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.color !== prevProps.color && this.props.color !== this.state.color) {
            this.setState({ color: this.props.color, tempColor: this.props.color });
        }
    }

    handleInputClick = () => {
        this.setState({
            showPicker: !this.state.showPicker,
            tempColor: this.state.color
        });
    };

    handleTempChange = (newColor) => {
        this.setState({ tempColor: newColor.hex }); // solo provisional
    };

    handleAccept = () => {
        this.setState(
            { color: this.state.tempColor, showPicker: false },
            () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.color); // solo al aceptar
                }
            }
        );
    };

    handleCancel = () => {
        this.setState({ showPicker: false, tempColor: this.state.color }); // descarta cambios
    };

    render() {
        const { color, tempColor, showPicker } = this.state;

        return (
            <>
                <input
                    type="text"
                    value={color}
                    readOnly
                    onClick={this.handleInputClick}
                    style={{
                        width: "120px",
                        padding: "6px",
                        border: "1px solid #333",
                        borderRadius: "4px",
                        textAlign: "center",
                        backgroundColor: color,
                        color: "#fff",
                        cursor: "pointer",
                        fontWeight: "bold"
                    }}
                />
                {showPicker && (
                    <div
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}
                    >
                        <SketchPicker
                            color={tempColor}
                            onChange={this.handleTempChange}
                        />
                        <div
                            style={{
                                marginTop: "12px",
                                display: "flex",
                                gap: "8px"
                            }}
                        >
                            <button
                                onClick={this.handleAccept}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #333",
                                    borderRadius: "6px",
                                    backgroundColor: "#333",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    cursor: "pointer"
                                }}
                            >
                                Aceptar
                            </button>
                            <button
                                onClick={this.handleCancel}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #999",
                                    borderRadius: "6px",
                                    backgroundColor: "#f5f5f5",
                                    color: "#333",
                                    cursor: "pointer"
                                }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}



InputColor.propTypes = {
    className: PropTypes.string,
    color: PropTypes.number,
    onChange: PropTypes.func,
}

export default InputColor